import MyTypography from "@saleor/components/MyTypography";
import { ContractQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import moment from "moment-timezone";
import React from "react";
import { useIntl } from "react-intl";

interface ContractInfoProps {
  contractData: ContractQuery["contract"];
}

const useStyles = makeStyles(
  theme => ({
    boxCustomer: {
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: 6,
      marginBottom: "2.4rem"
    },
    boxTitle: {
      padding: "0.8rem 1.6rem",
      background: theme.palette.gardient.medium,
      color: "#FFF",
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6
    },
    boxBody: {
      background: "#FFF",
      padding: "0.8rem 1.6rem"
    },
    boxCustomerRowInfo: {
      padding: "0.9rem 1.2rem",
      background: theme.palette.background.default,
      display: "flex",
      alignItems: "center",
      margin: "0.8rem 0",
      borderRadius: 4
    },
    infoName: {
      minWidth: 128,
      color: theme.palette.info.main
    },
    infoContent: {
      width: "calc(100% - 128px)"
    },
    boxContract: {
      background: "#FFF",
      padding: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: 6
    },
    boxContractRowInfo: {
      padding: "0.8rem 1.2rem",
      display: "flex",
      alignItems: "center",
      margin: 0,
      borderRadius: 4
    },
    boxContractInfoContent: {
      width: "calc(100% - 128px)",
      color: theme.palette.grey[800]
    },
    infoTitle: {
      minWidth: 128
    }
  }),
  { name: "ContractInfoDraw" }
);

const ContractInfo: React.FC<ContractInfoProps> = props => {
  const { contractData } = props;
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <div className={classes.boxCustomer}>
        <div className={classes.boxTitle}>
          <MyTypography variant={"caption"} color="inherit">
            {intl.formatMessage({ defaultMessage: "เลขที่ Contract" })}
          </MyTypography>
          <MyTypography variant={"h6"} color="inherit">
            {contractData?.contractNo}
          </MyTypography>
        </div>
        <div className={classes.boxBody}>
          <div className={classes.boxCustomerRowInfo}>
            <MyTypography variant={"body3"} className={classes.infoTitle}>
              {intl.formatMessage({ defaultMessage: "รหัสลูกค้า" })}
            </MyTypography>
            <MyTypography variant={"body3"} className={classes.infoContent}>
              {contractData?.customer?.soldToCode}
            </MyTypography>
          </div>
          <div className={classes.boxCustomerRowInfo}>
            <MyTypography variant={"body3"} className={classes.infoTitle}>
              {intl.formatMessage({ defaultMessage: "ชื่อลูกค้า" })}
            </MyTypography>
            <MyTypography variant={"body3"} className={classes.infoContent}>
              {contractData?.customer?.soldToName}
            </MyTypography>
          </div>
        </div>
      </div>
      <div className={classes.boxContract}>
        <div className={classes.boxContractRowInfo}>
          <MyTypography variant={"body3"} className={classes.infoName}>
            {intl.formatMessage({ defaultMessage: "Company" })}
          </MyTypography>
          <MyTypography variant={"body3"} className={classes.infoContent}>
            {contractData?.company?.shortName}
          </MyTypography>
        </div>
        <div className={classes.boxContractRowInfo}>
          <MyTypography variant={"body3"} className={classes.infoName}>
            {intl.formatMessage({ defaultMessage: "ชื่อโครงการ" })}
          </MyTypography>
          <MyTypography
            variant={"body3"}
            className={classes.boxContractInfoContent}
          >
            {contractData?.projectName}
          </MyTypography>
        </div>
        <div className={classes.boxContractRowInfo}>
          <MyTypography variant={"body3"} className={classes.infoName}>
            {intl.formatMessage({ defaultMessage: "เงื่อนไขการชำระเงิน" })}
          </MyTypography>
          <MyTypography
            variant={"body3"}
            className={classes.boxContractInfoContent}
          >
            {contractData?.paymentTermDescTh}
          </MyTypography>
        </div>
        <div className={classes.boxContractRowInfo}>
          <MyTypography variant={"body3"} className={classes.infoName}>
            {intl.formatMessage({ defaultMessage: "วันที่เริ่มต้น" })}
          </MyTypography>
          <MyTypography
            variant={"body3"}
            className={classes.boxContractInfoContent}
          >
            {moment(contractData?.startDate).format("DD/MM/YYYY")}
          </MyTypography>
        </div>
        <div className={classes.boxContractRowInfo}>
          <MyTypography variant={"body3"} className={classes.infoName}>
            {intl.formatMessage({ defaultMessage: "วันที่สิ้นสุด" })}
          </MyTypography>
          <MyTypography
            variant={"body3"}
            className={classes.boxContractInfoContent}
          >
            {moment(contractData?.endDate).format("DD/MM/YYYY")}
          </MyTypography>
        </div>
      </div>
    </>
  );
};

export default ContractInfo;
